// extracted by mini-css-extract-plugin
export var reactMarkdown = "markdown-module--reactMarkdown--767a0";
export var tabletOnly = "markdown-module--tablet-only--305d8";